export const GET_JOB_TYPES = '/api/job/types'
export const ADD_JOB = '/api/job/add'
export const GET_JOBS = '/api/job/all'
export const GET_JOB = '/api/job/get'
export const DELETE_JOB = '/api/job/delete'
export const UPDATE_JOB = '/api/job/update'



// WEBPACK FOOTER //
// ./src/api/jobs/types.js